import type { TEmailTagsMutation } from './useEmailTagsMutation.types.ts';
import { useApi } from '#providers/api/index.ts';
import { getSettingsQueryKey } from '#providers/projects/Projects.helpers.ts';
import { useProjectMutation } from '#providers/projects/use-project-mutation/index.ts';
import { useProjects } from '#providers/projects/use-projects/index.ts';

export const useEmailTagsMutation = (): TEmailTagsMutation => {
  const api = useApi();
  const { currentProjectId, requireProjectId } = useProjects();
  const settingsKey = getSettingsQueryKey(currentProjectId);

  const { mutateAsync, isPending, error } = useProjectMutation(
    api.tagging.setEmailTags,
    requireProjectId,
    [settingsKey],
  );

  return {
    isSettingEmailTags: isPending,
    setEmailTagsError: error ?? undefined,
    setEmailTags: mutateAsync,
  };
};
